import React, { useState, useEffect } from 'react';

const HomeSlider = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      id: 1,
      image: '/imgs/home-Fondo_1.jpg',
      text: 'Especialistas en Envases'
    },
    {
      id: 2,
      image: '/imgs/home-slide4.jpg',
      text: 'Especialistas en Envases'
    },
    {
      id: 3,
      image: '/imgs/home-slide6.jpg',
      text: 'Fabricación de Envases en Microcorrugado, Corrugado\n& Cartulinas'
    },
    {
      id: 4,
      image: '/imgs/home-sllide3.jpg',
      text: 'Amplia Trayectoria en la Industria'
    },
    {
      id: 5,
      image: '/imgs/home-Troqueladora1.jpg',
      text: 'Envases en Microcorrugado, Corrugado  y Cartulinas'
    },
    {
      id: 6,
      image: '/imgs/home-varios.png',
      text: 'Amplia Trayectoria en la Industria'
    }
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prevSlide) => (prevSlide + 1) % slides.length);
    }, 4000); // Change slide every 4 seconds

    return () => clearInterval(timer);
  }, [slides.length]);

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  const goToPrevious = () => {
    setCurrentSlide((prevSlide) => (prevSlide - 1 + slides.length) % slides.length);
  };

  const goToNext = () => {
    setCurrentSlide((prevSlide) => (prevSlide + 1) % slides.length);
  };

  return (
    <div className="home-slider-container">
      <button className="home-slider-nav home-slider-nav-prev" onClick={goToPrevious}>
        ‹
      </button>
      
      <div className="home-slider-track" style={{ transform: `translateX(-${currentSlide * 100}%)` }}>
        {slides.map((slide, index) => (
          <div key={slide.id} className="home-slider-slide">
            <img 
              src={slide.image} 
              alt={`Slide ${index + 1}`}
              className="home-slider-image"
            />
            <div className="home-slider-text-overlay">
              <p className="home-slider-text">
                {slide.text.split('\n').map((line, i) => (
                  <span key={i}>
                    {line}
                    {i < slide.text.split('\n').length - 1 && <br />}
                  </span>
                ))}
              </p>
            </div>
          </div>
        ))}
      </div>

      <button className="home-slider-nav home-slider-nav-next" onClick={goToNext}>
        ›
      </button>

      {/* Slide indicators (match empresa styles) */}
      <div className="empresa-slider-indicators">
        {slides.map((_, index) => (
          <button
            key={index}
            className={`empresa-slider-indicator ${index === currentSlide ? 'active' : ''}`}
            onClick={() => goToSlide(index)}
            aria-label={`Ir al slide ${index + 1}`}
          />
        ))}
      </div>
    </div>
  );
};

export default HomeSlider;

